module.exports = __webpack_public_path__ + "static/media/appointment-sc.71db63c1.png";